var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7619 3.5H15.2619V2C15.2619 1.60218 15.0963 1.22064 14.8016 0.93934C14.5069 0.658035 14.1072 0.5 13.6905 0.5H8.97617C8.5594 0.5 8.1597 0.658035 7.865 0.93934C7.5703 1.22064 7.40474 1.60218 7.40474 2V3.5H1.90474C1.48797 3.5 1.08827 3.65804 0.793574 3.93934C0.498874 4.22064 0.333313 4.60218 0.333313 5V17C0.333313 17.3978 0.498874 17.7794 0.793574 18.0607C1.08827 18.342 1.48797 18.5 1.90474 18.5H20.7619C21.1787 18.5 21.5784 18.342 21.8731 18.0607C22.1678 17.7794 22.3333 17.3978 22.3333 17V5C22.3333 4.60218 22.1678 4.22064 21.8731 3.93934C21.5784 3.65804 21.1787 3.5 20.7619 3.5ZM8.97617 2H13.6905V3.5H8.97617V2ZM20.7619 5V11.75H1.90474V5H20.7619ZM1.90474 17V13.25H20.7619V17H1.90474Z",
    fill: "#673E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.7305b6bcaa9999e824e4b6239a9f96d6.svg";
export { ForwardRef as ReactComponent };